import {ListReducerBuilder} from '../../../../utils/reducers';
import {IDENTIFIER} from '../actions';

export default {
    partnerCompanies: ListReducerBuilder.build(IDENTIFIER, false)
};
